var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBottomCenter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 145,
    height: 109,
    viewBox: "0 0 145 109",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5418_13962)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_5418_13962)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_5418_13962)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M141.133 2.59375H4.72931C2.17563 2.59375 0.105469 4.66391 0.105469 7.21759V102.006C0.105469 104.56 2.17563 106.63 4.72931 106.63H141.133C143.686 106.63 145.757 104.56 145.757 102.006V7.21759C145.757 4.66391 143.686 2.59375 141.133 2.59375Z",
    fill: "#ECECEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5542 16.4601C15.5119 16.4601 16.2882 15.6837 16.2882 14.7261C16.2882 13.7685 15.5119 12.9922 14.5542 12.9922C13.5966 12.9922 12.8203 13.7685 12.8203 14.7261C12.8203 15.6837 13.5966 16.4601 14.5542 16.4601Z",
    fill: "#EF4444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3355 16.4601C21.2931 16.4601 22.0694 15.6837 22.0694 14.7261C22.0694 13.7685 21.2931 12.9922 20.3355 12.9922C19.3779 12.9922 18.6016 13.7685 18.6016 14.7261C18.6016 15.6837 19.3779 16.4601 20.3355 16.4601Z",
    fill: "#FCD34D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1167 16.4601C27.0744 16.4601 27.8507 15.6837 27.8507 14.7261C27.8507 13.7685 27.0744 12.9922 26.1167 12.9922C25.1591 12.9922 24.3828 13.7685 24.3828 14.7261C24.3828 15.6837 25.1591 16.4601 26.1167 16.4601Z",
    fill: "#83E83F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.793 24.5547H17.4442C14.8905 24.5547 12.8203 26.6249 12.8203 29.1785V46.5179C12.8203 49.0716 14.8905 51.1418 17.4442 51.1418H123.793C126.346 51.1418 128.416 49.0716 128.416 46.5179V29.1785C128.416 26.6249 126.346 24.5547 123.793 24.5547Z",
    fill: "#4B22A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.0128 55.7734H15.7102C14.1142 55.7734 12.8203 57.0673 12.8203 58.6633V58.6633C12.8203 60.2594 14.1142 61.5532 15.7102 61.5532H55.0128C56.6089 61.5532 57.9027 60.2594 57.9027 58.6633C57.9027 57.0673 56.6089 55.7734 55.0128 55.7734Z",
    fill: "#4B22A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.1719 84.1406C84.1719 78.0655 79.247 73.1406 73.1719 73.1406C67.0967 73.1406 62.1719 78.0655 62.1719 84.1406C62.1719 90.2158 67.0967 95.1406 73.1719 95.1406C79.247 95.1406 84.1719 90.2158 84.1719 84.1406Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.9974 85.0052C72.5316 85.0052 72.1374 84.8439 71.8147 84.5212C71.4921 84.1986 71.3307 83.8043 71.3307 83.3386V79.3385C71.3307 78.8728 71.4921 78.4785 71.8147 78.1559C72.1374 77.8332 72.5316 77.6719 72.9974 77.6719C73.4632 77.6719 73.8574 77.8332 74.1801 78.1559C74.5027 78.4785 74.6641 78.8728 74.6641 79.3385V83.3386C74.6641 83.8043 74.5027 84.1986 74.1801 84.5212C73.8574 84.8439 73.4632 85.0052 72.9974 85.0052ZM72.4974 89.8386V87.641C71.3974 87.5154 70.4835 87.0436 69.7557 86.2257C69.028 85.4077 68.6641 84.4453 68.6641 83.3386H69.6641C69.6641 84.2608 69.9891 85.0469 70.6391 85.6969C71.2891 86.3469 72.0752 86.6719 72.9974 86.6719C73.9196 86.6719 74.7057 86.3469 75.3557 85.6969C76.0057 85.0469 76.3307 84.2608 76.3307 83.3386H77.3307C77.3307 84.4453 76.9668 85.4077 76.2391 86.2257C75.5113 87.0436 74.5974 87.5154 73.4974 87.641V89.8386H72.4974Z",
    fill: "black"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5418_13962"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 144.837,
    height: 107.558,
    fill: "white",
    transform: "translate(0.105469 0.90625)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_5418_13962"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 145.651,
    height: 107.804,
    fill: "white",
    transform: "translate(0.105469 0.90625)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_5418_13962"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 145.651,
    height: 104.429,
    fill: "white",
    transform: "translate(0.105469 2.59375)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottomCenter);
export default __webpack_public_path__ + "static/media/BottomCenter.d96d13395873e3aaee86a619b2352441.svg";
export { ForwardRef as ReactComponent };